import { Slider } from "@/components/Slider";
import { HumanConfiguration, SliderUIElement } from "@/types/evaluate";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

export const HumanInputUIComponent = ({
  uiComponent,
  dataType,
  config,
  value,
  setValue,
}: {
  uiComponent: string;
  dataType: string;
  config: HumanConfiguration;
  value: any | null;
  setValue: (value: any) => void;
}) => {
  if (uiComponent === "text") {
    if (dataType === "number") {
      return (
        <Input
          className={`col-span-2 w-full rounded border border-gray-300 px-2 py-1 font-mono`}
          value={value}
          type="number"
          onChange={(e) => setValue(Number(e.target.value))}
        />
      );
    } else {
      return (
        <Textarea
          className={`col-span-2 w-full rounded border border-gray-300 px-2 py-1 text-sm`}
          value={value}
          rows={4}
          onChange={(e) => setValue(e.target.value)}
        />
      );
    }
  } else if (uiComponent === "slider") {
    const sliderConfig = config.ui_element as SliderUIElement;
    const min = sliderConfig.min || 0;
    const max = sliderConfig.max || 100;

    return (
      <Slider
        onValueChange={(value) => setValue(Math.round(Number(value)))}
        value={value?.toString() || "0"}
        isDisabled={false}
        min={min}
        max={max}
        step={0.99}
        hasInput
      />
    );
  }
  return <div>Unknown UI component</div>;
};
